import { render, staticRenderFns } from "./historialFilters.vue?vue&type=template&id=4a398a80"
import script from "./historialFilters.vue?vue&type=script&lang=js"
export * from "./historialFilters.vue?vue&type=script&lang=js"
import style0 from "./historialFilters.vue?vue&type=style&index=0&id=4a398a80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports